import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { SharedService } from './shared.service';
import { Favorite, FavoriteCriteria } from '../common';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService {
  constructor(private http: HttpClient, private store: Store) { }
  get count() {
    if (FavoriteService._count == undefined) {
      FavoriteService._count = 0;
      this.search({}, 0, 1).then(_ => FavoriteService._count = _.total);
    }
    return FavoriteService._count;
  }

  get favorites() { return JSON.parse(localStorage.getItem('favorites') || '[]'); }
  set favorites(favorites: Favorite[]) {
    if (!favorites || !favorites.length) { localStorage.removeItem('favorites'); } else { localStorage.setItem('favorites', JSON.stringify(favorites)); }
  }
  static _count: number;

  search(criteria: FavoriteCriteria, from = 0, limit = 10) {
    if (criteria.ItemIds)
      criteria.ItemIds = criteria.ItemIds.filter(_ => _ != 'content');
    if (!this.store.selectSnapshot(state => state.auth.user)) {
      const favorites = this.favorites.filter(_ =>
        (criteria.IsExpired == undefined || criteria.IsExpired == _.ExpirationTime.getTime() < Date.now()) &&
        (criteria.Type == undefined || _.Type == criteria.Type) &&
        (!criteria.ItemIds || !criteria.ItemIds.length || criteria.ItemIds.includes(_.ItemId))
      );
      return new Promise<{ total: number, favorites: Favorite[] }>(resolve => resolve({
        total: favorites.length,
        favorites: favorites.slice(from, Math.min(from + limit, favorites.length))
      }));
    } else {
      return this.http.post<{ total: number, favorites: Favorite[] }>(environment.app.apiUrl + 'favorite/search/' + `${from}/${limit}`, criteria, { context: SharedService.NO_LOADING_BAR }).toPromise();
    }
  }

  private reset(_) { delete FavoriteService._count; return _; }

  toggle(favorite: Favorite) {
    if (!this.store.selectSnapshot(state => state.auth.user)) {
      const index = this.favorites.findIndex(_ => _.ItemId == favorite.ItemId);
      if (index < 0) { this.favorites = [...this.favorites, favorite]; } else { this.favorites = this.favorites.filter(_ => _.ItemId !== favorite.ItemId); }
      return new Promise<boolean>(resolve => resolve(index < 0)).then(this.reset);
    } else {
      return this.http.post<boolean>(environment.app.apiUrl + 'favorite/toggle', favorite).toPromise().then(this.reset);
    }
  }

  sync() {
    if (this.store.selectSnapshot(state => state.auth.user) && this.favorites.length) {
      return this.http.post(environment.app.apiUrl + 'favorite/sync', this.favorites).toPromise().then(this.reset);
    }
  }
}
